
<template>
  <pop-up-layout 
    :title="$t('toolbar.cambiarPassword')"
    @volver="$parent.hide()"
  >
    <v-layout justify-center>
      <v-flex xs12 sm8 md6 lg5 xl3>
        <CambiarPassword
          @passwordModificada="passwordModificada"
        />
      </v-flex>
    </v-layout>
  </pop-up-layout>
</template>

<script>
import CambiarPassword from './CambiarPassword'
export default {
  components: {
    CambiarPassword
  },
  methods: {
    passwordModificada () {
      this.$parent.hide()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cambiarPassword/CambiarPasswordPopUp.vue